import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, Checkbox, Table, TableBody, TableCell, TableHead, TableRow, FormHelperText } from '@mui/material';
import { RightsContext } from 'providers/RightsContext';
import OfferPaymentPlanAdvanceSplitRowComponent from './OfferPaymentPlanAdvanceSplitRowComponent';
import { Button } from '@totalsoft/rocket-ui';
import { GridActionsWrapper } from 'components/common/CommonStyles';

const OfferPaymentPlanAdvanceSplitComponent = ({
  advanceSplit,
  splitValues,
  t,
  onAdd,
  onPropertyChange,
  onSave,
  changeAdvanceIsSplitted,
  onDelete,
  saving,
  checkSumOfAdvanceSplitValuesValid,
  advanceData
}) => {
  const { readOnlyFull, isImage, downPaymentSplitWrite } = useContext(RightsContext);

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <span>{t('OfferEdit.AdvanceSplit.AdvanceIsAmount')}</span>
          <Checkbox
            id={'offerPaymentPlanAdvanceSplitCard_advanceIsAmount'}
            checked={Boolean(advanceSplit.advanceSplitIsAmount)}
            onChange={changeAdvanceIsSplitted}
            disabled={readOnlyFull || !downPaymentSplitWrite}
          />
        </Grid>

        <Grid item xs={12}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>{t('OfferEdit.AdvanceSplit.DueDate')}</strong>
                </TableCell>
                <TableCell>
                  <strong>
                    {t('OfferEdit.AdvanceSplit.Amount')} {advanceSplit.advanceSplitIsAmount ? advanceData.currencyCode : '%'}
                  </strong>
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {splitValues.map(({ document }, idx) => {
                return (
                  <OfferPaymentPlanAdvanceSplitRowComponent
                    key={idx}
                    idx={idx}
                    splitValueRow={document}
                    onPropertyChange={(prop, value, orderNo) => onPropertyChange(idx, prop, value, orderNo)}
                    readOnlyFull={readOnlyFull}
                    onDelete={() => onDelete(idx)}
                    downPaymentSplitWrite={downPaymentSplitWrite}
                  />
                );
              })}
            </TableBody>
          </Table>
        </Grid>

        {!checkSumOfAdvanceSplitValuesValid() && (
          <Grid item xs={12}>
            {advanceSplit.advanceSplitIsAmount ? (
              <FormHelperText error={true} id='splitValues-error-text'>
                {t('OfferEdit.AdvanceSplit.SumValid', {
                  data: { advanceAmount: advanceData.advance, currencyCode: advanceData.currencyCode }
                })}
              </FormHelperText>
            ) : (
              <FormHelperText error={true} id='splitValues-error-text'>
                {t('OfferEdit.AdvanceSplit.PercentSumValid')}
              </FormHelperText>
            )}
          </Grid>
        )}

        <GridActionsWrapper item mt={1}>
          {!isImage && (
            <Button id={'offerPaymentPlanAdvanceSplitCard_addBtn'} color='primary' onClick={onAdd} disabled={!downPaymentSplitWrite}>
              {t('Add')}
            </Button>
          )}
          {!isImage && (
            <Button
              id={'offerPaymentPlanAdvanceSplitCard_saveBtn'}
              color='primary'
              onClick={onSave}
              disabled={saving || !advanceSplit.isDirty || !checkSumOfAdvanceSplitValuesValid() || !downPaymentSplitWrite}
            >
              {saving ? t('Saving') : t('Save')}
            </Button>
          )}
        </GridActionsWrapper>
      </Grid>
    </>
  );
};

OfferPaymentPlanAdvanceSplitComponent.propTypes = {
  advanceSplit: PropTypes.object.isRequired,
  splitValues: PropTypes.array,
  t: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  changeAdvanceIsSplitted: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  checkSumOfAdvanceSplitValuesValid: PropTypes.func.isRequired,
  advanceData: PropTypes.object
};

export default withTranslation()(OfferPaymentPlanAdvanceSplitComponent);
